import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import headerBackground from './Images/header-background.png';
import Footer from './components/Footer';

let styles = (theme) => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: theme.spacing(1),
  },
  buttonLogin: {
    fontWeight: 'bold',
    color: '#F9F9F9',
    backgroundColor: '#009E49',
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingTop: theme.spacing(1.1),
    paddingBottom: theme.spacing(1.1),
    fontSize: 18,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    flex: 1,
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingTop: theme.spacing(10),
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#E1E1E1',
  },
  eVisaText: {
    marginTop: theme.spacing - 35,
    display: 'flex',
    justifyContent: 'center',
    width: 90,
    backgroundColor: '#ffffff',
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
    color: '#B3B3B3',
    fontSize: 30,
  },
  infoText: {
    margin: theme.spacing(2),
    fontSize: 17,
  },
  footerContainer: {
    // marginTop: theme.spacing.unit * 20,
    backgroundColor: '#201F1F',
  },
  footerBar: {
    backgroundColor: '#201F1F',
    padding: theme.spacing(2),
  },
  textFooterTerms: {
    color: '#7C7A7A',
    fontWeight: 'bold',
    marginRight: theme.spacing(2),
  },
  textFooter: {
    color: '#7C7A7A',
    fontWeight: 'bold',
  },
  trademarkText: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

let theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#D7ECE1',
      dark: '#FFCDD2',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

let sectionStyle = {
  height: '345px',
  backgroundImage: `url(${headerBackground})`,
};

function NoMatch(props) {
  let { classes } = props;
  let { t } = useTranslation();
  let [height, setHeight] = useState(window.innerHeight);

  function onWindowResize() {
    const { height } = this.state;
    if (window.innerHeight !== height) {
      setHeight(window.innerHeight);
    }
  }

  useEffect(() => {
    window.addEventListener('resize', onWindowResize, false);
    return () => {
      window.removeEventListener('resize', onWindowResize, false);
    };
  }, []);

  return (
    <div className={classes.root} style={{ height }}>
      <div className={classes.headerContainer} style={sectionStyle}>
        <Typography
          style={{ color: '#ffffff', fontWeight: 'bold' }}
          variant="h3"
          align="center"
          gutterBottom
        >
          {t('pageNotFound')}
        </Typography>
      </div>
      <div className={classes.description}>
        <Typography
          className={classes.infoText}
          variant="body1"
          align="center"
          gutterBottom
        >
          {t('404')}
        </Typography>
        <div className={classes.buttonsContainer}>
          <MuiThemeProvider theme={theme}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/"
              className={classes.buttonLogin}
            >
              {t('home')}
            </Button>
          </MuiThemeProvider>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default withStyles(styles)(NoMatch);



// WEBPACK FOOTER //
// ./src/view/scenes/NoMatch.js